import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/merchant/partner`;

export default {
  show() {
    return Client.get(`${resource}`);
  },
  options(payload) {
    payload.order = "name";
    payload.sort = "asc";
    return Client.get(`${resource}/option`, {
      params: payload
    });
  },
};
